<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Booking Analysis</h3>
      </d-col>
    </d-row>
    <!-- Content -->
    <d-row>
      <d-col lg="10" md="12" sm="12" class="mb-4">
        <div class="card card-small h-100">
          <!-- Card Header -->
          <div class="card-header border-bottom">
            <h6 class="m-0">Booking</h6>
          </div>
          <!-- Chart -->
          <div class="card-body d-flex py-0">
            <canvas
              ref="canvas_booking"
              class="blog-users-by-device m-auto bookingcanvas"
              id="bookingcanvas"
            ></canvas>
          </div>
          <d-card-footer class="border-top">
            <d-row>
              <!-- Time Frame -->

              <!-- View Full Report -->
            </d-row>
          </d-card-footer>
        </div>
      </d-col>
      <d-col lg="10" md="12" sm="12" class="mb-4">
        <div class="card card-small h-100">
          <!-- Card Header -->
          <div class="card-header border-bottom">
            <h6 class="m-0">Info</h6>
          </div>
          <div class="card-body d-flex py-0">
            <div class="topref_box">
              <div class="topref_box_two">
                <div class="topref_boxcon" v-for="(item, idx) in 1" :key="idx">
                  <p class="topref_boxconhead" id="mostdata"></p>
                  <p class="topref_boxconbody" id="mostdatavalues"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template> 
 
<script>
</script>

<script>
import axios from "axios";
import Chart from "../utils/chart";

export default {
  name: "users-by-device",
  data() {
    return {
      datasets: [],
      article: [],
      savetop3ViewsArticles: [],
      savedataByCategories: [],
      savebookingdata: [],
    };
  },
  mounted() {
    this.onpageloadbooking_data();
  },
  methods: {
    init() {
      new Chart(this.$refs.canvas, chartConfig);
    },

    init_booking() {
      //booking chart
      var tempdata = [];
      var booking_datas = [];
      for (
        var saveweek = 0;
        saveweek < this.savebookingdata.length;
        saveweek++
      ) {
        tempdata[saveweek] =
          this.savebookingdata[saveweek].numberOfBookingRecords;
        booking_datas.push(tempdata[saveweek]);
      }

      // <block:setup:1>
      const weekdate = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      // </block:setup>
      var data = {
        labels: weekdate,
        datasets: [
          {
            label: "Booking View",
            //data: booking_datas,
            data: [70, 60, 50, 30, 40, 10, 20],
            fill: false,
            borderColor: [
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
            ],
            backgroundColor: [
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
            ],
            borderWidth: 2,
            tension: 0,
            xAxisID: "bar-x-axis1",
          },
          {
            label: "Booking View",
            data: [10, 20, 30, 40, 50, 60, 70],
            fill: false,
            borderColor: [
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
              "rgba(34,52,78, 1)",
            ],
            backgroundColor: [
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
              "rgba(181,193,210,1)",
            ],
            borderWidth: 2,
            tension: 0,
            xAxisID: "bar-x-axis2",
          },
        ],
      };

      var options = {
        legend: {
          labels: {
            fontColor: "black",
            fontSize: 12,
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              id: "bar-x-axis1",
              barThickness: 50,
            },
            {
              display: false,
              stacked: true,
              id: "bar-x-axis2",
              barThickness: 70,
              offset: true,
              // these are needed because the bar controller defaults set only the first x axis properties
              type: "category",
              categoryPercentage: 0.8,
              barPercentage: 0.9,
              gridLines: {
                offsetGridLines: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
      // <block:config:0>
      const booking_config = {
        type: "bar",
        data: data,
        options: options,
      };
      new Chart(this.$refs.canvas_booking, booking_config);
    },
    onpageloadbooking_data() {
      axios
        .get(process.env.VUE_APP_API + "api/staff/Report/booking")
        .then((response) => {
          //console.log(response.data)
          this.savebookingdata = response.data.result.weekdays;
          document.getElementById("mostdata").innerHTML = "Most Popular Day";
          document.getElementById("mostdatavalues").innerHTML =
            response.data.result.mostPopularDay;
          this.init_booking(); // set value load
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.toprefmain {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.topref_box {
  border-style: solid;
  border-width: 3px;
  border-style: solid;
  border-color: rgba(238, 245.03, 255, 1);
  display: inline;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.topref_boxcon {
  width: auto;
  height: 160px;
  padding: 35px;
  background-color: rgba(63.3, 116.69, 192.31, 1);
  border-style: solid;
  border-width: 3px;
  border-style: solid;
  border-color: white;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_boxconhead {
  font-size: 12px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_boxconbody {
  font-size: 48px;
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: white;
}

.topref_box_two {
}

.bookingcanvas {
}
</style>